import Product from "../../../../@types/Product";

const LugNuts: Product[] = [
    {
        id: 1,
        name: 'Lugnuts Chrome x4',
        sku: 'LUG4S',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lug-nuts/chrome.jpg`,
        price: 20.00,
        retailPrice: 0,
    },
    {
        id: 2,
        name: 'Lugnuts Black x4',
        sku: 'LUG4SB',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/lug-nuts/black.jpg`,
        price: 20.00,
        retailPrice: 0,
    },
]

export default LugNuts;